<template>
  <span class="readiness-circle" role="img" :aria-label="ariaLabel" :style="circleStyle">
    <img class="readiness-circle__icon" :src="iconSrc" alt="" aria-hidden="true" />
  </span>
</template>

<script setup>
import { computed } from "vue";

import { READINESS_CIRCLE_ICONS } from "./readinessCircleIcons";
import { getReadinessBand } from "./readinessBand";
import { snapReadinessValue } from "./snapReadinessValue";

const props = defineProps({
  /** Readiness percentage on the 0–150 scale; the icon snaps to the nearest step, the band uses the raw value. */
  value: {
    type: Number,
    required: true,
  },
  /** Pixel width/height override. Defaults to the Figma spec of 30px. */
  size: {
    type: Number,
    default: 30,
  },
});

const snappedStep = computed(() => snapReadinessValue(props.value));

const iconSrc = computed(() => READINESS_CIRCLE_ICONS[snappedStep.value]);

const ariaLabel = computed(() => {
  const band = getReadinessBand(props.value);
  return `${snappedStep.value}% readiness, ${band}`;
});

const circleStyle = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
}));
</script>

<style scoped>
.readiness-circle {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  overflow: hidden;
}

.readiness-circle__icon {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
